import QuickAction from './QuickAction';

export { Skeleton as QuickActionSkeleton } from './QuickAction';
export * from './QuickActionProps';
export default QuickAction;
